import {
  Button,
  MenuItem,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { StyledSelect, StyledTextField } from 'packages/ui/src/components';
import { CommonDataState } from 'state/commonState';
import { Form, useWatch } from 'react-hook-form';
import { Common } from '@crops';
import cn from 'classnames';
import mapState from 'state/mapState';
import pannelState from 'state/rightPannelState';
import CropApi from 'api/CropApi';
import CommonApi from 'api/CommonApi';
import ApiMapper from 'constant/ApiMapper';

export function SearchConsole({
  onSubmit,
  control,
  register,
  resetField,
  t_name,
  setDetail,
  setOpenBtn,
  formError,
  setValue,
}: any) {
  const mapStatus = useRecoilValue(mapState);

  const [pannel, setPannel] = useRecoilState(pannelState);

  const [hide, setHide] = useState(false);

  const { legend, ctpv } = useRecoilValue(CommonDataState);
  const [sggList, setSggList] = useState<Common.Tsgg[]>([]);
  const [emdList, setEmdList] = useState<Common.Temd[]>([]);

  const [searchMode, setSearchMode] = useState<'area'|'addr'>('area');


  //주소검색 자동완성 기능
  const onChangeValue = useWatch({ control, name: 'searchAddr' }); //들어가는 값
  const [isHaveInputValue, setIsHaveInputValue] = useState(false); //값의 유무
  const [dropDownList, setDropDownList] = useState([]); //단어목록, 최대 10개

  //지역조회, 주소조회 토글 선택 이벤트
  function jusoSearchToggle(e: any) {
    setSearchMode(searchMode === 'addr' ? 'area' : 'addr');
  }

  function jusoSearchChnage() {{
  setPannel((prev) => ({
      ...prev,
      status: {
        ...prev.status,
        searchMode: searchMode,
      },
    }));

  }}

  useEffect(() => {
    if (pannel.status.searchMode === 'addr') {
      resetField('sggCd');
      resetField('emdCd');
      resetField('ctpvCd');
      setEmdList([]);
    } else if (pannel.status.searchMode === 'area') {
      resetField('sggCd');
      resetField('emdCd');
      resetField('ctpvCd');
      resetField('searchAddr');
      setEmdList([]);
    }
  }, [pannel.status.searchMode]);

  const onChangeCltv = useWatch({ control, name: 'ctpvCd' });
  const onChangeSgg = useWatch({ control, name: 'sggCd' });
  const onChangeEmd = useWatch({ control, name: 'emdCd' });

  const bootstrap = ApiMapper.COMMON.BOOTSTRAP;

  const callSgg = async (ctpvCd: string) => { 
    const sgg = await CommonApi.ListSgg({ url: bootstrap.SGG_LIST , regionCode: ctpvCd });    
    setSggList(sgg);
    resetField('sggCd');
    resetField('emdCd');
    setEmdList([]);
  }

  const callEmd = async (sggCd: string) => {  
    const emd = await CommonApi.ListEmd({ url: bootstrap.EMD_LIST, regionCode: sggCd });
    setEmdList(emd);
    resetField('emdCd');
  }

  useEffect(() => {
    if (onChangeCltv){
     callSgg(onChangeCltv);
    }

  }, [onChangeCltv]);

  useEffect(() => {
    if (onChangeSgg){
    callEmd(onChangeSgg);
  }
  }, [onChangeSgg]);


  //주소 자동완성 기능 구현
  const showDropDownList = async () => {
    if (onChangeValue === '') {
      setIsHaveInputValue(false);
      setDropDownList([]);
    } else {
      //값을 통해서 api 호출
      const result = await CropApi.SearchAddr({ sggCd: onChangeSgg, emdCd: onChangeEmd, searchAddr: onChangeValue });
      setDropDownList(result); //result 값 넣기
    }
  };

  const changeValue = (dt) => {
    setValue('searchAddr', dt.addr);
  };

  useEffect(() => {
    if (onChangeSgg !== '0' && onChangeEmd !== '0') showDropDownList();
  }, [onChangeValue]);

  return (
    <div className={`mapLayer mapLayerBig ${cn({ hide })}`}>
      {/* 재배 작물 조회창, hide : 레이어창을 닫았을 경우 추가, mapLayerBig : 조회하는 레이어창일 경우 추가 */}
      <div className="mapLayerTitArea">
        <div className="mapLayerTit">
          <span>{t_name}</span>
        </div>
        <button
          type="button"
          className="mapLayerTitBtn"
          onClick={() => setHide((prev) => !prev)}
        >
          <span>레이어창 버튼</span>
        </button>
      </div>
      <div className="mapLayerConArea">
        <div className="mlcTit">위치 선택</div>
        <div className="mlcCon">
          <div className="cRadio">
            <input
              type="radio"
              id="radioItem0000"
              name="radioItem00"
              defaultValue={searchMode}
              onChange={jusoSearchToggle}
              defaultChecked
            />
            <label htmlFor="radioItem0000">지역조회</label>
          </div>
          <div className="cRadio">
            <input
              type="radio"
              id="radioItem0001"
              name="radioItem00"
              defaultValue={searchMode}
              onChange={jusoSearchToggle}
            />
            <label htmlFor="radioItem0001">주소조회</label>
          </div>
          {/* mlcResult : 위치 선택 결과 영역 */}
          <div className="mlcResult">
            <div className="cFlex">
            <StyledSelect
                name="ctpvCd"
                control={control}
                sx={{ width: '100%' }}
              >
                <MenuItem value="0">전체</MenuItem>
                {ctpv.map((ct) => (
                  <MenuItem
                    value={ct.ctpv_cd}
                    key={ct.ctpv_cd}
                  >
                    {ct.ctpv_nm}
                  </MenuItem>
                ))}
              </StyledSelect>

              <StyledSelect
                name="sggCd"
                sx={{ width: '100%' }}
                control={control}
              >
                <MenuItem value="0">전체</MenuItem>
                {sggList.map((column) => (
                  <MenuItem
                    key={column.sgg_cd}
                    value={column.sgg_cd}
                  >
                    {column.sgg_nm}
                  </MenuItem>
                ))}
              </StyledSelect>
              <StyledSelect
                name="emdCd"
                control={control}
                sx={{ width: '100%' }}
              >
                <MenuItem value="0">전체</MenuItem>
                {emdList.map((emd) => (
                  <MenuItem
                    value={emd.emd_cd}
                    key={emd.emd_cd}
                  >
                    {emd.emd_nm}
                  </MenuItem>
                ))}
              </StyledSelect>
            </div>
            <Form
              control={control}
              onSubmit={()=>{onSubmit(); jusoSearchChnage();}} 
            >
              {searchMode === 'addr' ? (
                <>
                  <div className="cSearchBox">
                    <input
                      type="text"
                      {...register('searchAddr', { required: true })}
                      className="cSearchBoxInput"
                      placeholder="주소를 검색해 주세요."
                      onFocus={() => {
                        setIsHaveInputValue(false);
                      }}
                    />
                    <button
                      type="button"
                      className="cSearchBoxBtn"
                      onClick={() => resetField('searchAddr')}
                    >
                      <span>텍스트 삭제 버튼</span>
                    </button>
                    <span
                      className="cSearchBoxIcon"
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        setIsHaveInputValue(false);
                        showDropDownList();
                      }}
                    ></span>
                  </div>
                  <div className="mlcAddressArea">
                    {dropDownList.length > 0 && onChangeValue.length > 0 && !isHaveInputValue ? (
                      <ul className="mlcAddressSelect">
                        {dropDownList.map((dt, idx) => (
                          <li
                            key={idx}
                            onClick={() => {
                              changeValue(dt);
                              setIsHaveInputValue(true);
                            }}
                          >
                            {dt.addr}
                          </li>
                        ))}
                      </ul>
                    ) : null}

                    {dropDownList.length === 0 && onChangeValue.length > 0 && !isHaveInputValue ? (
                      <div className="mlcAddressEmpty">
                        <div className="con">조회 결과가 존재하지 않습니다.</div>
                      </div>
                    ) : null}
                  </div>

                  {formError.searchAddr?.type === 'required' && (
                    <Typography
                      color="red"
                      variant="caption"
                      className="cSupportText"
                    >
                      주소를 검색해 주세요.
                    </Typography>
                  )}
                </>
              ) : null}
            </Form>
          </div>
        </div>
        {/* {searchMode === 'area' ? ( */}
          <div className="mlcResult">
            <div className="mlcTit">임산물 선택</div>
            <div className="mlcCon">
              <StyledSelect
                name="treeKindCd"
                control={control}
                sx={{ width: '100%' }}
              >
                <MenuItem value="0">전체</MenuItem>
                {legend.map((crop) => (
                  <MenuItem
                    key={crop.cmmn_cd_id}
                    value={crop.cmmn_cd_id}
                  >
                    {crop.cmmn_cd_val}
                  </MenuItem>
                ))}
              </StyledSelect>
            </div>
          </div>
        
        {/* ): null} */}
        <Button
          variant="contained"
          onClick={onSubmit}
          disabled={mapStatus.status.loadStart}
          className="bHeight04"
        >
          <span>확인</span>
        </Button>
      </div>
    </div>
  );
}
